// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TrendSvg from '@rsuite/icon-font/lib/charts/Trend';
var Trend = createSvgIcon({
  as: TrendSvg,
  ariaLabel: 'trend',
  category: 'charts',
  displayName: 'Trend'
});
export default Trend;